import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useTranslate } from 'react-admin';
import customDataProvider from '../../../providers/data-provider';
import {
  getDataFromWebService,
  getOptions,
  height,
} from '../../../utils/chart';

ChartJS.register(LinearScale, BarElement, Title, Tooltip, Legend);

const PostsByAuthorChart: React.FC = () => {
  const theme = useTheme();
  const translate = useTranslate();
  const [postsCount, setPostsCount] = React.useState<any>({});

  React.useEffect(() => {
    customDataProvider
      .request('/posts/count/author')
      .then((response) => setPostsCount(response));
  }, []);

  const data = getDataFromWebService(postsCount, translate, 'author');

  const options = getOptions(theme, true);

  return <Bar height={height} data={data} options={options} />;
};

export default PostsByAuthorChart;
